<header
  class="fixed inset-x-0 top-0 z-50 w-full border-b border-gray-200 bg-white transition-all duration-300"
  [class.lg:left-[300px]]="!sidebarCollapsed()"
>
  <nav
    class="relative flex w-full min-w-0 items-center justify-between gap-2 px-2 py-2 sm:gap-3 sm:px-3 md:px-4"
  >
    <div class="flex items-center gap-x-2">
      <button
        type="button"
        class="inline-flex size-9 items-center justify-center rounded border border-transparent text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-ring)]"
        (click)="handleToggleSidebar()"
        [attr.aria-expanded]="!sidebarCollapsed()"
        aria-label="Alternar sidebar"
      >
        <span class="sr-only">Alternar sidebar</span>
        <i
          class="bi text-base"
          [ngClass]="sidebarCollapsed() ? 'bi-arrow-bar-right' : 'bi-arrow-bar-left'"
        ></i>
      </button>

      <span
        class="flex items-center whitespace-nowrap text-sm font-medium text-gray-700"
      >
        {{ applicationTitle() }}
      </span>
    </div>
  </nav>
</header>
